import useUrl from './helpers/useUrl'

export default (client,{ apiUrl }) => {
  const baseUrl = useUrl(`${apiUrl}/notifications`)

  return {

    /**
     * @param {object} GetUserDTO
     * @param {string} GetUserDTO.userId
     *
     * @returns {Promise<Response<GetUserResponse>>}
     */
    postUser({ id }) {
      const url = baseUrl('/public/onesignal/register')
      const data = { onesignalId: id }
      return client.post(url, data)
    },
  }
}

/**
 * @typedef {object} GetUserResponse
 * @prop {boolean} status
 * */
